<template>
  <div class="block">
    <i v-show="showChangeType" @click="changeType()" :class="icon_color+' el-icon-setting'"></i>
    <span v-if="type==='daterange'">
    <el-date-picker
      :popper-class="'date-range-'+class_type"
      class="date-time-range"
      :editable="false"
      v-model="init_time"
      type="daterange"
      unlink-panels
      range-separator="`"
      prefix-icon=" "
      :default-time="[ '00:00:00', '23:59:59' ]"
      :picker-options="pickerOptions"
      append-to-body>
    </el-date-picker>
    </span>
    <span v-if="type==='datetimerange'">
    <el-date-picker
      :popper-class="'date-range-'+class_type"
      class="date-time-range"
      :editable="false"
      v-model="init_time"
      type="datetimerange"
      unlink-panels
      range-separator="`"
      prefix-icon=" "
      :default-time="[ '00:00:00', '23:59:59' ]"
      :picker-options="pickerOptions"
      append-to-body>
    </el-date-picker>
    </span>
  </div>
</template>

<script>
  export default {
    data() {
        const init_time = this.notDefaultValue?['','']:[ new Date(new Date().setHours(0, 0, 0, 0)), new Date(new Date().setHours(23, 59, 59, 0)) ];
        const class_type = this.$cache.browse_model;
        return {
        class_type: class_type,
        pickerOptions: {
            shortcuts: [
                {
                    text: 'Today',
                    onClick: this.daysPeriod(0)
                },
                {
                    text: 'yesterday',
                    onClick: this.yesterdayPeriod()
                },
                {
                    text: 'Last 3 days',
                    onClick: this.daysPeriod(3)
                },
                {
                    text: 'Last 7 days',
                    onClick: this.daysPeriod(7)
                },
                {
                    text: 'Last 30 days',
                    onClick: this.daysPeriod(30)
                },
                {
                    text: 'This Month',
                    onClick: this.monthPeriod(0)
                },
                {
                    text: 'Last Month',
                    onClick: this.monthPeriod(1)
                },
            ],
        },
        type: 'daterange',
        icon_color: 'icon-color-1',
        datetimerange_class: '',
        init_time:this.initTime && this.initTime.length !== 0 ? this.initTime : init_time,
        };
    },
	props: {
		dateValue: {
			type: Boolean,
			default:false,
		},
		notDefaultValue:{
			type:Boolean,
			default:false
        },
        set_hourly: {
            type:Boolean,
            default:false
        },
        initTime: {
            type: Array,
            default: () => { return [] },
        },
        showChangeType: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        daysPeriod(num){
            return function(picker){
                this.init_time = [];
                const end = new Date().setHours(23, 59, 59, 0);
                const start = end - 86400000 * num - 23 * 3600000 - 3600000 + 1000;
                this.init_time[0] = new Date(start);
                this.init_time[1] = new Date(end);
                picker.$emit('pick',this.init_time);
            }
        },
        yesterdayPeriod(){
            return function(picker){
                this.init_time = [];
                const timestamp = new Date().setHours(0, 0, 0, 0) ;
                this.init_time[0] = new Date(timestamp - 86400000);
                this.init_time[1] = new Date(timestamp - 1000);
                picker.$emit('pick',this.init_time);
            }
        },
        monthPeriod(num){
            return function(picker){
                this.init_time = [];
                const date = new Date();
                const y = date.getFullYear();
                const m = date.getMonth() - num;
                this.init_time[0] = new Date(y,m,1);
                this.init_time[1] = new Date(y,m+1,0,23,59,59);
                picker.$emit('pick',this.init_time);
            }
        },
        setInput(){
            let input = '';
            if(Array.isArray(this.init_time) && this.init_time.length === 2){
                input = {};
                let start = new Date(
                    Date.UTC(
                        this.init_time[0].getFullYear(),
                        this.init_time[0].getMonth(),
                        this.init_time[0].getDate()
                    )
                );
                let end = new Date(
                    Date.UTC(
                        this.init_time[1].getFullYear(),
                        this.init_time[1].getMonth(),
                        this.init_time[1].getDate()
                    )
                );
                const add_start_hour = this.init_time[0].getHours();
                const add_end_hour = this.init_time[1].getHours() + 1;
                start = new Date(start.getTime() + add_start_hour * 3600 * 1000);
                end = new Date(end.getTime() + add_end_hour * 3600 * 1000 - 1000);
                
                if (this.type === 'datetimerange') {
                    start = new Date(this.init_time[0]);
                    end = new Date(this.init_time[1]);
                }
                if(this.dateValue) {
                    input['$gte'] = start;
                    input['$lt'] = end;
                } else {
                    input['$gte'] = new Date(start).getTime() / 1000;
                    input['$lt'] = new Date(end).getTime() / 1000;
                }
            }
            this.$emit("input",input);
        },
        changeType() {
            if (this.type === 'datetimerange') {
                this.type = 'daterange';
                this.icon_color = 'icon-color-1';
                this.init_time[0] = new Date(new Date(this.init_time[0]).setHours(0, 0, 0, 0));
                this.init_time[1] = new Date(new Date(this.init_time[1]).setHours(23, 59, 59, 0));
            } else {
                this.type = 'datetimerange';
                this.icon_color = 'icon-color-2';
            }
        }

    },
    mounted() {
        if(!this.notDefaultValue) {
            this.setInput();
        }
    },
    updated() {
        this.setInput();
    }
  };
</script>
<style>
.date-range-phone{
    top: 80px !important;
    left: 300px !important;
}
.block {
    display:flex;
    align-items: center;
}
.icon-color-1 {
    color:#999898;
    font-size: 25px;
}
.icon-color-2 {
    color:#5e6cbb;
    font-size: 25px;
}
.date-time-range {
    width: 260px !important;
}
</style>